import type { PropTypes } from './InfoIconButton.types';

import { IconButton } from '@rango-dev/whale';
import { Info } from 'lucide-react';
import React, { forwardRef } from 'react';

const DEFAULT_ICON_SIZE = 12;

/**
 * Ghost info (ⓘ) icon button.
 *
 * Refs are forwarded so it can be used directly as an `asChild` trigger for
 * Radix's Tooltip / HoverCard / Popover primitives.
 */
export const InfoIconButton = forwardRef<HTMLButtonElement, PropTypes>(
  function InfoIconButton(props, ref) {
    const {
      id,
      iconSize = DEFAULT_ICON_SIZE,
      variant = 'ghost',
      color = 'gray',
      size = '1',
      ...rest
    } = props;

    return (
      <IconButton id={id} ref={ref} variant={variant} color={color} size={size} {...rest}>
        <Info size={iconSize} />
      </IconButton>
    );
  },
);
